module.exports = __webpack_public_path__ + "static/media/InnerBox_Right.bc7e7667.svg";